export var op_list = `
{{#operations}}
    {{> operations/_op_row sar_tenant = ../sar_tenant energy_tenant = ../energy_tenant redcross_tenant = ../redcross_tenant current_tenant=../tenant token=../token client_isadmin = ../client_isadmin client_ismanager = ../client_ismanager}}
{{/operations}}
`